import { TabsProps, TabItem } from '../Tabs/types';

export interface TabbedContentProps
  extends Omit<TabsProps, 'isTablist' | 'onKeyDown'> {
  /** Tabs to be displayed */
  items: ({ id: string } & TabItem)[];
  /** A render function which is called on every tab, with the tab’s id.
  This is where consumers pass the content of the tab panel.
  */
  children(id: number): React.ReactNode;
  /** Will be passed to tablist component */
  'aria-label'?: string;
  /** Will be passed to tablist component */
  'aria-labelledby'?: string;
  /** Will be passed to tablist component */
  'aria-describedby'?: string;
}

export enum TabbedContentDataHooks {
  activeContentContainer = 'active-content',
  contentContainer = 'content-container',
}
